import { ModuleWithProviders, NgModule } from '@angular/core';
import { AzureModuleOptions } from './azure.types';
import { AZURE_MODULE_OPTIONS } from './azure.token';
import { AzureAuthService } from './azure-auth.service';

@NgModule({ providers: [AzureAuthService] })
export class AzureModule {
  static forRoot(
    options: AzureModuleOptions,
  ): ModuleWithProviders<AzureModule> {
    return {
      ngModule: AzureModule,
      providers: [{ provide: AZURE_MODULE_OPTIONS, useValue: options }],
    };
  }
}
